module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread",
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'deviceManager'
      }
    }
  }, [_vm._v("设备管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("修改设备")])], 1), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "deviceForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.deviceForm,
      "rules": _vm.devicerules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备编号",
      "prop": "deviceId"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "disabled": "",
      "placeholder": "设备编号"
    },
    model: {
      value: (_vm.deviceForm.deviceId),
      callback: function($$v) {
        _vm.$set(_vm.deviceForm, "deviceId", $$v)
      },
      expression: "deviceForm.deviceId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备名称",
      "prop": "deviceName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "clearable": "",
      "placeholder": "设备名称"
    },
    model: {
      value: (_vm.deviceForm.deviceName),
      callback: function($$v) {
        _vm.$set(_vm.deviceForm, "deviceName", $$v)
      },
      expression: "deviceForm.deviceName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "机构信息",
      "prop": "orgId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "机构信息"
    },
    model: {
      value: (_vm.deviceForm.orgId),
      callback: function($$v) {
        _vm.$set(_vm.deviceForm, "orgId", $$v)
      },
      expression: "deviceForm.orgId"
    }
  }, _vm._l((_vm.orgList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.org_name,
        "value": item.org_id
      }
    }, [_vm._v(_vm._s(item.org_name))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "设备地址"
    },
    model: {
      value: (_vm.deviceForm.address),
      callback: function($$v) {
        _vm.$set(_vm.deviceForm, "address", $$v)
      },
      expression: "deviceForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "id": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('deviceForm')
      }
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.cancelSubmit()
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c6a332e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/device/modifyDevice.vue
// module id = 1076
// module chunks = 2